import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { AlertService } from "../services/alert.service";
import { EnvService } from "../services/env.service";
import { AuthService } from "../services/auth.service";

@Component({
  selector: "micro-application-tag-detail",
  templateUrl: "./applicationTag-detail.component.html",
})
export class ApplicationTagDetailComponent implements OnInit {
  @Input() applicationTagId: any;
  @Output() persisted = new EventEmitter<any>();
  @Output() selectedItemsChange: EventEmitter<any> = new EventEmitter<any>();
  applicationTag: any;

  allApplications: any[] = [];
  selectedApplications: any[] = [];

  constructor(
    public auth: AuthService,
    private env: EnvService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private alertService: AlertService,
  ) {}

  ngOnInit(): void {
    if (this.applicationTagId) {
      this.load(this.applicationTagId);
    } else {
      this.route.params.subscribe((params: Params) => {
        params["id"] === "0" ? this.createNew() : this.load(params["id"]);
      });
    }
  }

  load(id: string): void {
    this.applicationTagId = id;
    this.http
      .get(`${this.env.e.url}/domain/cmdbApplicationTags/${id}`)
      .subscribe((data) => {
        this.applicationTag = data;
        this.reload();
      });
  }

  createNew(): void {
    this.applicationTag = {
      name: "",
      operationalStatus: "",
      description: "",
      companyId: this.auth.getCompanyId(),
    };
  }

  save(): void {
    const isUpdate = !!this.applicationTag.id;
    const request = isUpdate
      ? this.http.put(
          `${this.env.e.url}/domain/cmdbApplicationTags/${this.applicationTag.id}`,
          this.applicationTag,
        )
      : this.http.post(
          `${this.env.e.url}/domain/cmdbApplicationTags`,
          this.applicationTag,
        );
    request.subscribe((data) => {
      this.applicationTag = data;

      this.http
        .patch(
          `${this.env.e.url}/domain/cmdbApplications?tagId=${this.applicationTag.id}`,
          this.selectedApplications,
        )
        .subscribe(() => {
          this.alertService.info(
            `${isUpdate ? "Updated" : "Created"} ${this.applicationTag.name}`,
          );
          this.persisted.emit({ data, action: isUpdate ? "updated" : "added" });
        });
    });
  }

  delete(): void {
    this.http
      .delete(
        `${this.env.e.url}/domain/cmdbApplicationTags/${this.applicationTag.id}`,
      )
      .subscribe(() => {
        this.persisted.emit({ data: this.applicationTag, action: "deleted" });
        this.alertService.info(`Deleted ${this.applicationTag.name}`);
        if (!this.applicationTagId) {
          this.router.navigate(["/applicationTags"]);
        }
      });
  }

  reload() {
    return this.http
      .get(
        `${this.env.e.url}/domain/cmdbApplications/findAllByTag?applicationTagId=${this.applicationTagId}&companyId=${this.applicationTag.companyId}`,
      )
      .subscribe((data) => {
        this.allApplications = data as any[]; //.filter((app) => !app.applicationTagId || app.applicationTagId === this.applicationTagId);

        this.selectedApplications = this.allApplications
          .filter((app) => app.applicationTagId === this.applicationTagId)
          .map((app) => app.id);
      });
  }

  onNgModelChange(e: any) {
    this.selectedItemsChange.emit(e);
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (let prop in changes) {
      if (prop === "companyId") {
        this.reload();
      }
    }
  }
}
